const formatYear = (year) => {
  if (!year) return '';

  return  `‘${year.toString().slice(-2)}`;
};

const formatDateRange = (dates, options) => {
  const { fillYear, month, locale } = options || {};

  if (!Array.isArray(dates)) {
    return null;
  }

  const [startString, endString] = dates;

  if (!startString) {
    return null;
  }

  const startDate = startString && new Date(startString);
  const endDate = endString && new Date(endString);

  const s = startDate && {
    year: startDate.getFullYear(),
    month: startDate.getMonth(),
    day: startDate.getDate(),
  };

  const e = endDate && {
    year: endDate.getFullYear(),
    month: endDate.getMonth(),
    day: endDate.getDate(),
  };

  const commonFormattedYear = fillYear || s.year !== new Date().getFullYear() ? s.year : '';

  // One day
  if (!e || (e.year === s.year && e.month === s.month && e.day === s.day)) {
    const start = startDate.toLocaleDateString(locale || 'ru', { day: '2-digit', month: month || 'long' });
    return (`${start} ${formatYear(commonFormattedYear)}`.replace(/\./g, '')).trim();
  }

  // One month
  if (s.year === e.year && s.month === e.month) {
    const start = startDate.toLocaleDateString(locale || 'ru', { day: '2-digit' });
    const end = endDate.toLocaleDateString(locale || 'ru', { day: '2-digit', month: month || 'long' });
    return (`${start}–${end} ${formatYear(commonFormattedYear)}`.replace(/\./g, '')).trim();
  }

  // One year
  if (s.year === e.year) {
    const start = startDate.toLocaleDateString(locale || 'ru', { day: '2-digit', month: month || 'short' });
    const end = endDate.toLocaleDateString(locale || 'ru', { day: '2-digit', month: month || 'short' });
    return (`${start} – ${end} ${formatYear(commonFormattedYear)}`.replace(/\./g, '')).trim();
  }

  const start = startDate.toLocaleDateString(locale || 'ru', { day: '2-digit', month: month || 'short' });
  const end = endDate.toLocaleDateString(locale || 'ru', { day: '2-digit', month: month || 'short' });
  return (`${start} ${formatYear(s.year)} – ${end} ${formatYear(e.year)}`.replace(/\./g, '')).trim();
};

export default formatDateRange;
